
const Form = ({useEnter, ...props}) => {
  const preventEnter = e => {
    if (e.key === 'Enter') {
      e.stopPropagation();
      e.preventDefault();
    }
  };
  return <form {...props} onKeyDown={!useEnter ? preventEnter : null}>
    { props.children }
  </form>
}

export default Form;
